/**
 * Extract plain text from TipTap JSON document
 * @param {Object} docJson - TipTap JSON document
 * @param {number} maxChars - Maximum characters to extract
 * @returns {string} Plain text preview
 */
export function extractPlainTextFromTipTap(docJson, maxChars = 600) {
  if (!docJson || !docJson.content) return '';

  let text = '';

  const extractFromNode = (node) => {
    if (text.length >= maxChars) return;

    if (node.type === 'text') {
      text += node.text || '';
    } else if (node.content && Array.isArray(node.content)) {
      node.content.forEach(child => extractFromNode(child));
    }

    // Add spacing after block elements
    if (['paragraph', 'heading', 'listItem'].includes(node.type)) {
      text += ' ';
    }
  };

  docJson.content.forEach(node => extractFromNode(node));

  // Trim and truncate
  text = text.trim();
  if (text.length > maxChars) {
    text = text.slice(0, maxChars).trim() + '...';
  }

  return text;
}



